import * as moment from "moment";
export type DateTimeType =
    | 'seconds'
    | 'minutes'
    | 'hours'
    | 'days'
    | 'months'
    | 'years';

export class TimeDateUtilities {
    public getTimeStringByLanguage(time: string, lang: string, delta: number = 0, deltaType: DateTimeType = 'minutes'): string {
        switch (lang) {
            case "es":
                return this.getSpanishtime(time, delta, deltaType);
            case "fr":
                return this.getFrenchTime(time, delta, deltaType);
            default:
                return this.getEnglishTime(time, delta, deltaType);
        }
    }
    private applyDelta(time: string, delta: number, deltaType: DateTimeType) {
        const units: moment.unitOfTime.DurationConstructor = deltaType;
        return moment(time).add(delta, units)
    }
    private getFrenchTime(time: string, delta: number, deltaType: DateTimeType): string {
        return this.applyDelta(time, delta, deltaType).format("HH:mm").replace(/\:/, 'h');
    }
    private getEnglishTime(time: string, delta: number, deltaType: DateTimeType): string {
        return this.applyDelta(time, delta, deltaType).format("h:mm a");
    }
    private getSpanishtime(time: string, delta: number = 0, deltaType: DateTimeType): string {
        return this.applyDelta(time, delta, deltaType).format("HH:mm");
    }
}
export default new TimeDateUtilities();


// WEBPACK FOOTER //
// ./src/constants/TimeAndDate.ts